export const CookieNames = {
  browserTheme: '__canny__browserTheme',
  experimentID: '__canny__experimentID',
  locale: '__canny__locale',
  requestID: '__canny__requestID',
  sessionID: '__canny__sessionID',
  userID: '__canny__userID',
};
